import {
  Activity,
  Archive,
  BriefcaseMedical,
  ClipboardList,
  Database,
  DatabaseBackup,
  DatabaseSearch,
  DatabaseZap,
  File,
  FileCheck,
  Files,
  FileStack,
  FileText,
  FolderOpen,
  Forward,
  Gauge,
  HeartPulse,
  Mail,
  Monitor,
  NotebookPen,
  Pill,
  Receipt,
  ScanLine,
  Search,
  Stethoscope,
  Syringe,
  Upload,
  UserPlus,
  Wind,
} from "lucide-react";

const FALLBACK_MAP = {
  OPD_LETTER: FileStack,
  RECEIPTS: Receipt,
  LETTER: File,
  FORM: FileText,
  E_REFERRAL: Monitor,
  OTHER_REFERRAL: Files,
  OTHER_DOCUMENT: Archive,
  PRESCRIPTIONS: Pill,
  SCAN: ScanLine,
};

const ICON_NAME_MAP = {
  Activity,
  Archive,
  BriefcaseMedical,
  ClipboardList,
  Database,
  DatabaseBackup,
  DatabaseSearch,
  DatabaseZap,
  File,
  FileCheck,
  Files,
  FileStack,
  FileText,
  FolderOpen,
  Forward,
  Gauge,
  HeartPulse,
  Mail,
  Monitor,
  NotebookPen,
  Pill,
  PillIcon: Pill,
  Receipt,
  ScanLine,
  Search,
  Stethoscope,
  Syringe,
  Upload,
  UserPlus,
  Wind,
};

const toIconKey = (name) =>
  name
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");

export const getDocumentTypeIcon = (typeName, iconName) => {
  if (iconName) {
    const key = toIconKey(iconName);
    if (ICON_NAME_MAP[key]) return ICON_NAME_MAP[key];
  }
  return FALLBACK_MAP[typeName] || FileText;
};

export const formatDocumentTypeLabel = (name) => {
  if (!name) return "";
  return name
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
